<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div epub:type="bodymatter">
<section epub:type="division">
<div class="img"><a id="pageiii"></a><img alt="" src="OEBPS/images/tp.jpg"/></div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454927839_epub_tp_r1.vue?0722bc0d